import { FC } from 'react'
import { IoChevronBackCircleOutline } from 'react-icons/io5'
import s from './ChevronBackCircleOutline.module.scss'
export type ChevronBackCircleOutlineProps = {} & React.ComponentProps<
  typeof IoChevronBackCircleOutline
>
const ChevronBackCircleOutline: FC<ChevronBackCircleOutlineProps> = ({
  ...props
}) => {
  return <IoChevronBackCircleOutline className={s.root} {...props} />
}

export default ChevronBackCircleOutline
